import motoboyDelivery from './motoboy-delivery'

export default {
  namespaced: true,
  modules: {
    motoboyDelivery,
  },
  state: {},
  mutations: {},
  actions: {},
}
